$(document).ready(function () {
    const swiper = new Swiper('.see_inaction_carrusel', {
      slidesPerView: 2.5,
      spaceBetween: 30,
      dots: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      autoplay: {
        delay: 5000,
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          spaceBetween: 20
        },
        // when window width is >= 480px
        800: {
          slidesPerView: 2.5,
          spaceBetween: 30
        }
      }
    });
  });